import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class ShipDeliService {
  private apiUrl = '/spring/ships/deli';

  constructor(private http: HttpService) { }

  checkByOrder(
    picknoCd: string,
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl}/order/check`;
    const jsonInput = {
      picknoCd: picknoCd,
      updprogramCd: updprogramCd
    };
    return this.http.post(url, jsonInput);
  }

  printByPick(
    printagentCd: string,
    printerCd: string,
    picknoCd: string,
    pickdetnoCd: string,
    reprintFl: number,
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl}/case/print`;
    const jsonInput = {
      printagentCd: printagentCd,
      printerCd: printerCd,
      picknoCd: picknoCd,
      pickdetnoCd: pickdetnoCd,
      reprintFl: reprintFl,
      updprogramCd: updprogramCd
    };
    return this.http.post(url, jsonInput);
  }

  printByOrder(
    printagentCd: string,
    printerCd: string,
    picknoCd: string,
    caseList: any,
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl}/order/print`;
    const jsonInput = {
      printagentCd: printagentCd,
      printerCd: printerCd,
      picknoCd: picknoCd,
      cases: caseList,
      updprogramCd: updprogramCd
    };
    return this.http.post(url, jsonInput);
  }
  
  printByShipcaseList(
    printagentCd: string,
    printerCd: string,
    shipcaseIdList : Set<number>,
    updprogramCd: string
    
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl}/print`;
    const jsonInput = {
           printagentCd: printagentCd,
           printerCd: printerCd,
           updprogramCd: updprogramCd,
           shipcaseIdList: Array.from(shipcaseIdList.values())
       };
    
    return this.http.post(url, jsonInput);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/ship-deli/ship-deli.service.ts